import type { FaireProductEntity } from "../../entity_types/product";

export const p_n2km9rkjkt: FaireProductEntity = {
  token: "p_n2km9rkjkt",
  type: "product",
  name: "Sweetgrass Plant Basket: Kupanua",
  brandToken: "b_6jbk8zuc",
  brandName: "Amsha",
  imageUrl: "https://cdn.faire.com/fastly/fa1cd4d96f787fc34b4a4368535c7b3d837b80e798b0162660fec3360fd37fa3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/99cdbd60ec0446a11778541e60dd3c8a025ba4b3b401c00905b9b8f5a78a23da.jpeg",
    "https://cdn.faire.com/fastly/93aa328983add672422cb5aa1faae9aba67390eaec8c5029f87d19c0d94b1e99.jpeg",
    "https://cdn.faire.com/fastly/458ccb4ac291a0f1dd5eb7d3d2ef6e37c97cfeca14fa83747ae505daaee00891.jpeg"
  ],
  priceDollars: 18,
  description: "These woven basket planters are handmade by our artisans in Rwanda, using sweetgrass and banana leaf. Use these African baskets as a desk accessory, a plant holder, or to brighten up a shelf! Plant not included.\n\nColor: Natural Sweetgrass\n\nMedium: 5\" x 5\" (holds 4\" plant)\nLarge: 7\" x 7\" (holds 5-6\" plant)",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:16.212Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
